import { render, staticRenderFns } from "./data-table-review.vue?vue&type=template&id=6ef7b636&"
import script from "./data-table-review.vue?vue&type=script&lang=ts&"
export * from "./data-table-review.vue?vue&type=script&lang=ts&"
import style0 from "./data-table-review.vue?vue&type=style&index=0&id=6ef7b636&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports